/**
 * Bundle Scripts
 */

// Polyfills
import 'babel-polyfill';
import 'svgxuse';
import 'object-fit-images';

// Import Libs
import './lib/bling';

// CSS Import
import '../css/app.scss';


// Import Partials
import scripts from './partials/scripts';
import templates from './partials/templates';
import modules from './partials/modules';

// import UIkit from './vendor/uikit';
// import Icons from './vendor/uikit-icons';

// loads the Icon plugin

const app = {

    init() {
        scripts.init();
        templates.init();
        modules.init();

        // UIkit.use(Icons);
    }
};

// Init App!
app.init();



// WEBPACK FOOTER //
// ./___src/assets/js/app.js